// import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'

export default {
  namespaced: true,

  state () {
    return {
      categories: [],
      getting: false
    }
  },

  getters: {
    list: state => {
      return state.categories
    }
  },

  mutations: {
    add (state, categories) {
      state.categories = categories
    },
    getStart (state) {
      state.getting = true
    },
    getComplete (state) {
      state.getting = false
    }
  },

  actions: {
    get ({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        if (state.getting) {
          reject(Errors.create({
            message: 'Already getting'
          }))
        }
        commit('getStart')
        // Api.Categories.getCategories()
        // .then((response) => {
        // })
        // .catch((error) => {
        // })
        const fakeReponse = {
          categories: [
            { name: 'Sans Serif', myfontsId: 587 },
            { name: 'Serif', myfontsId: 345 },
            { name: 'Slab Serif', myfontsId: 896 },
            { name: 'Script', myfontsId: 123 },
            { name: 'Handwritten', myfontsId: 456 },
            { name: 'Picture & Icon', myfontsId: 789 },
            { name: 'Display', myfontsId: 901 }
          ]
        }
        commit('add', fakeReponse.categories)
        commit('getComplete')
        resolve()
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
